import { trackLink, trackView } from "~/helpers/trackings";
import { formatValueTrackings } from "./helpers";
import { STORE_CODE } from "./constants";

/**
 * @TODO da confermare
 */
export const trackRegistration = async (callback) => {
  trackLink({
    event_name: `${STORE_CODE}:registrazione`,
    link_id: "registrazione 24OrePro",
    event_type: "registrazione",
    no_view: "no"
  }, callback, `MCL @CLICK: registrazione`)
}
/**
 * @TODO da confermare
 */
export const trackLogin = async (callback?:Function) => {
  trackLink({
    event_name: `${STORE_CODE}:login`,
    link_id: "login 24OrePro",
    event_type: "login",
    no_view: "no"
  }, callback, `MCL @CLICK: login`)
}